import React from 'react';
import './Loading.css';

function Loading({ message = "Loading..." }) {
  return (
    <div className="loading-container">
      <div className="loading-wrapper">
        <ul className="loading-grid">
          {[...Array(25)].map((_, index) => (
            <li key={index} className="loading-cell"></li>
          ))}
        </ul>
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
}

export default Loading;
